import { Box, Skeleton } from '@mui/material'
import { RfhColors } from '../../config/florimixColors'

export const TransactionSelectAllBarSkeleton = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        pl: 7,
        pr: 2,
        py: 1,
        backgroundColor: RfhColors.lightGrey,
      }}
    >
      <Skeleton variant='text' animation='wave' width={100} height={24} />
      <Skeleton variant='text' animation='wave' width={70} height={24} />
    </Box>
  )
}
